export default function useStaticData() {
  const staticData = JSON.parse(localStorage.getItem("staticData"));
  return { staticData };
}
